/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_P3dInputs */

const en_mk_sol_startup_p3d = /** @type {(inputs: Mk_Sol_Startup_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copying context from the tracker into a chatbot and pasting the answer back is its own chore, and nobody wants it.`)
};

const id_mk_sol_startup_p3d = /** @type {(inputs: Mk_Sol_Startup_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyalin konteks dari tracker ke chatbot lalu menempel hasilnya kembali adalah pekerjaan tersendiri yang tidak ada yang mau melakukannya.`)
};

/**
* | output |
* | --- |
* | "Copying context from the tracker into a chatbot and pasting the answer back is its own chore, and nobody wants it." |
*
* @param {Mk_Sol_Startup_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_p3d = /** @type {((inputs?: Mk_Sol_Startup_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_p3d(inputs)
	return en_mk_sol_startup_p3d(inputs)
});